import React, { Component } from "react";

import Detail from "../Detail/Detail";
import Button, {
  buttonTypes,
  actionTypes
} from "@bit/fabfitfun.shared.global.button";

import analytics, { events } from "../../../utils/analytics";
import { showReactivatePopUpOrPage } from "../../../utils/abTestUtils";

class UpgradeMembership extends Component {

  showPopupContent = () => {
    // Wordpress popup integration hack
    // This should not carry over once we move the popup to React
    const popup = document.querySelector(
      ".pum-content.popmake-content .not-for-expired"
    );
    if (popup) {
      popup.classList.remove("not-for-expired");
    }
  };

  render() {
    const { cta, desc, title, showGrowthReactivatePopUp } = this.props;

    const element = document.getElementById("header-reactivate-cta");

    return (
      <Detail icon={"fa-star"} title={title} description={desc}>
        <Button
          type={buttonTypes.PRIMARY.value}
          action={actionTypes.CALL_TO_ACTION.value}
          label={cta}
          id={"header-reactivate-cta"}
          style={{ 
            width: "100%",
            marginTop: "16px"
          }}
          onClick={() => {
            analytics.track(events.CLICKED_ELEMENT, {
              element_name: "Reactivate Now",
              option_title: "Header"
            });
            showReactivatePopUpOrPage(showGrowthReactivatePopUp);
          }}
        />
      </Detail>
    );
  }
}

export default UpgradeMembership;



// WEBPACK FOOTER //
// ./src/Components/Header/ReactivateSubscription/ReactivateSubscription.js